import * as fromDatatype from "../datatype-library";

export interface bl_applet_notification_hdr_RowInterface{
    guid: fromDatatype.GuidDataFieldInterface;
    title: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    notification_subscription_hdr_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    scheduled_publish_date: fromDatatype.TimestampTzDatatypeInterface;
    last_publish_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    publish_status: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_applet_notification_hdr_RowClass implements bl_applet_notification_hdr_RowInterface{
    notification_subscription_hdr_guid: fromDatatype.GuidDataFieldInterface;
    scheduled_publish_date: fromDatatype.TimestampTzDatatypeInterface;
    last_publish_date: fromDatatype.TimestampTzDatatypeInterface;
    publish_status: fromDatatype.VarcharDatatypeInterface;
    title: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    guid: fromDatatype.GuidDataFieldInterface;
    event_code: fromDatatype.VarcharDatatypeInterface;
    topic_code: fromDatatype.VarcharDatatypeInterface;
    topic_description: fromDatatype.VarcharDatatypeInterface;
    topic_name: fromDatatype.VarcharDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    tenant_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    notification_type: fromDatatype.VarcharDatatypeInterface;
}
